import { AuthModal } from "components/organisms/modal/AuthModal";
import { useModal } from "mui-modal-provider";
import { useCallback } from "react";

export const useAuthModal = () => {
  const { showModal } = useModal();

  return {
    showAuthModal: useCallback(() => showModal(AuthModal), [showModal]),
  };
};
